// Guardian app (plan §7): home, history, authorised adults, one-time codes, the rotating pickup
// QR, requests and settings. `GuardianApp` runs in the Capacitor shell, `GuardianWeb` at /guardian/*.
export { GuardianApp, GuardianWeb } from "./App.tsx";
export { GuardianRoot } from "./GuardianRoot.tsx";
export { HomeView } from "./Home.tsx";
export { HistoryView, EventRecordView } from "./History.tsx";
export { AdultsView } from "./People.tsx";
export { CodeCard, untilMs, withinLimit } from "./Delegate.tsx";
export { PickupCodeView } from "./PickupCode.tsx";
export { RequestList } from "./Requests.tsx";
export { LegalLinks, magicTokenFrom } from "./SignIn.tsx";
export * from "./pass.ts";
export * from "./status.ts";
export { G, useGuardian, type GuardianCtx } from "./context.tsx";
